import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ButtonPrimary, ButtonSecondary, ButtonGhost, ButtonOutline } from '@grandvisionhq/iris-ui';
import '../../types/shared/products.js';
import '../../events/event-properties-provider.js';
import { useDispatchTrackClickEvent } from '../../events/use-track-click-event.js';
import '../../events/use-track-error-event.js';

var TealiumIrisUIButton = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { tealiumEvent  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "tealiumEvent"
    ]);
    const { onPress , variant  } = props, restProps = swcHelpers.objectWithoutProperties(props, [
        "onPress",
        "variant"
    ]);
    const dispatchTrackClickEvent = useDispatchTrackClickEvent();
    const handleClick = (event)=>{
        if (tealiumEvent) {
            try {
                dispatchTrackClickEvent(swcHelpers.objectSpread({}, tealiumEvent, {
                    Tracking_Type: 'link'
                }));
            } catch (error) {
                console.error('Tealium dispatch error:', error);
            }
        }
        if (onPress) {
            onPress(event);
        }
    };
    switch(variant){
        case 'outline':
            return /*#__PURE__*/ React.createElement(ButtonOutline, swcHelpers.extends({}, restProps, {
                onPress: handleClick,
                ref: ref
            }));
        case 'ghost':
            return /*#__PURE__*/ React.createElement(ButtonGhost, swcHelpers.extends({}, restProps, {
                onPress: handleClick,
                ref: ref
            }));
        case 'secondary':
            return /*#__PURE__*/ React.createElement(ButtonSecondary, swcHelpers.extends({}, restProps, {
                onPress: handleClick,
                ref: ref
            }));
        case 'primary':
        default:
            return /*#__PURE__*/ React.createElement(ButtonPrimary, swcHelpers.extends({}, restProps, {
                onPress: handleClick,
                ref: ref
            }));
    }
});
TealiumIrisUIButton.displayName = 'TealiumIrisUIButton';

export { TealiumIrisUIButton };
//# sourceMappingURL=TealiumIrisUIButton.js.map
